import './App.css'
import App from './components/App'
import { createRoot } from 'react-dom/client'
import onUnhandledPromiseRejection from './libs/onUnhandledPromiseRejection'
import { getGrooverText } from './libs/GrooverTextRepository'
import { startVersionReloadWatcher } from './libs/startVersionReloadWatcher'

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)
  root.render(<App />)
}

startVersionReloadWatcher({
  localVersion: import.meta.env.VITE_APP_VERSION,
  message: getGrooverText('appVersionNewVersionDetectedReloadingNow'),
  reloadLinkText: getGrooverText('appVersionReloadLink')
})

window.addEventListener('unhandledrejection', ({ reason: error }) => onUnhandledPromiseRejection(error))
